module.exports = __webpack_public_path__ + "static/media/logoanim-dark.2fc320b9.gif";